import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Nav from "@/components/site/Nav";
import ScrollVideoHero from "@/components/site/ScrollVideoHero";
import CtaSection from "@/components/site/CtaSection";
import CreditsSection from "@/components/site/CreditsSection";
import GalleryPage from "@/components/site/GalleryPage";
import StoryPage from "@/components/site/StoryPage";
import Footer from "@/components/site/Footer";

function Landing() {
  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <Nav />
      <main id="main">
        <ScrollVideoHero />
        <CtaSection />
        <CreditsSection />
      </main>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="site">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/story" element={<StoryPage />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
